export default __webpack_public_path__ + "static/create-branch-dialog-62f757af320ac0362dd85c8421b070ec.png";